import React, { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';

import {
  TEST_HOME_CHANNELS_TAB_BTN,
  TEST_HOME_EVERYONE_TAB_BTN,
  TEST_HOME_FEATURED_TAB_BTN,
  TEST_HOME_FOLLOWING_TAB_BTN,
} from 'constants/aqa/main';
import { useFeaturedFlagEnabled } from 'helpers/posthogHooks';
import { EFeaturedFlags } from 'types/EFeatureFlags';
import withHapticFeedback from 'helpers/withHapticFeedback';
import ScrollContainer from 'components/ScrollContainer';
import LatestPicks from 'pages/Explore/LatestPicks';
import { getTabFromPath, getPathForTab } from 'pages/Explore/helpers';
import { StyledWrap, StyledFixedTabs } from './styled';

import RadioButton from './RadioButton';
import { EExploreTabs } from './helpers/constants';
import { useExploreTabsBehavior } from './helpers/hooks';

const { Featured, Following, Everyone, Channels } = EExploreTabs;

const ExploreTabs: FC<{ isDark: boolean }> = ({ isDark }) => {
  const { pathname } = useLocation();
  const { push } = useHistory();

  const isShowChannelsTab = useFeaturedFlagEnabled(EFeaturedFlags.ShowChannelsTab);
  const isShowEveryOneTab = useFeaturedFlagEnabled(EFeaturedFlags.ShowEveryoneTab);

  const activeTab = getTabFromPath(pathname);
  const navigateTo = (tab: EExploreTabs) => withHapticFeedback(() => push(getPathForTab(tab)))();

  const { isHide, bgColor } = useExploreTabsBehavior();

  return (
    <StyledFixedTabs isHide={isHide} bgColor={bgColor}>
      <StyledWrap>
        <LatestPicks />
        <ScrollContainer spaceBetween={8}>
          <SwiperSlide>
            <RadioButton
              isDark={isDark}
              text={Featured}
              isChecked={activeTab === Featured}
              onClick={() => navigateTo(Featured)}
              dataTestId={TEST_HOME_FEATURED_TAB_BTN}
            />
          </SwiperSlide>
          <SwiperSlide>
            <RadioButton
              isDark={isDark}
              text={Following}
              isChecked={activeTab === Following}
              onClick={() => navigateTo(Following)}
              dataTestId={TEST_HOME_FOLLOWING_TAB_BTN}
            />
          </SwiperSlide>
          {isShowChannelsTab && (
            <SwiperSlide>
              <RadioButton
                isDark={isDark}
                text={Channels}
                isChecked={activeTab === Channels}
                onClick={() => navigateTo(Channels)}
                dataTestId={TEST_HOME_CHANNELS_TAB_BTN}
              />
            </SwiperSlide>
          )}
          {isShowEveryOneTab && (
            <SwiperSlide>
              <RadioButton
                isDark={isDark}
                text={Everyone}
                isChecked={activeTab === Everyone}
                onClick={() => navigateTo(Everyone)}
                dataTestId={TEST_HOME_EVERYONE_TAB_BTN}
              />
            </SwiperSlide>
          )}
        </ScrollContainer>
      </StyledWrap>
    </StyledFixedTabs>
  );
};

export default ExploreTabs;
